// IMPORTANT: Ensure the register module is imported first.
import '@/register'

import Boot from '@/Boot'
import { ErrorModal, OnlineStatusHandler, ReloadPrompt } from '@/components'
import router from '@/router'
import { ContextProviders as JSCProvider, PubSubProvider } from 'jobseeker-ui'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { ContextProviders } from './contexts'

import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <JSCProvider>
      <PubSubProvider>
        <ContextProviders>
          <Boot>
            <RouterProvider router={router} />
            <ReloadPrompt />
            {/* <UnauthorizedModal /> */}
            <OnlineStatusHandler />
            <ErrorModal />
          </Boot>
        </ContextProviders>
      </PubSubProvider>
    </JSCProvider>
  </>,
)
